<template lang="pug">
    v-row(justify="center")
        v-dialog(v-model="dialogConfirm" persistent="" max-width="500" class="dialog-confirm")
            v-card(style="border-radius: 10px; padding-left: 25px; padding-right: 25px;")
                v-card-title(class="text-h5 pt-8 px-8")
                div(class="text-center confirm-body pb-7")
                    img(:src="setIcon" class="mb-7")
                    slot(name="body")
                v-card-actions(class="justify-center")
                    slot(name="action")
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    actionFor: {
        type: String,
        default: 'confirm'
    },
    dialogConfirm: {
        type: Boolean,
        default: false
    },
  },
  computed: {
    setIcon(){
        const confirm = require('../../assets/confirm.png');
        const warning = require('../../assets/warning.png');
        return this.actionFor === 'confirm' ? confirm : warning;
    }
  }
}
</script>